import { ActivityFilterKey } from '../domain';
import { useSetFilter } from '../../filter';
import { StorageKeys } from '../../storage';

// Kept in lockstep with useActivityListFilter's map — see its comment for why
// a ternary can't represent a third ActivityFilterKey safely.
const STORAGE_KEY_BY_FILTER_KEY: Record<ActivityFilterKey, keyof StorageKeys> = {
  [ActivityFilterKey.Activity]: 'activityFilter',
  [ActivityFilterKey.AssetActivity]: 'assetActivityFilter',
  [ActivityFilterKey.AccountActivity]: 'accountActivityFilter',
  [ActivityFilterKey.AssetChat]: 'assetChatFilter',
};

export const useSetActivityListFilter = (filterKey: ActivityFilterKey) => {
  const storageKey = STORAGE_KEY_BY_FILTER_KEY[filterKey];

  return useSetFilter(filterKey, storageKey, true);
};
